import { from } from 'rxjs'

import { DriftMetricsAPI } from 'api'
import { rxCheckStatus, rxRetryWithBackoff } from 'utils/api'

export const sendDriftAppMetric = (metric) =>
  from(DriftMetricsAPI.post('/monitoring/metrics/add', metric)).pipe(
    rxCheckStatus(),
    rxRetryWithBackoff()
  )
